import {
  EXCLUDED_COVERAGE_FILTER_OPTIONS,
  getExcludedSubFilters,
} from './excluded-coverage-filters';

export const WEBHOOK_BUCKET_FILTER_OPTIONS = [
  {
    id: 'indexed',
    label: 'ایندکس‌شده',
    description:
      'صفحه در ایندکس گوگل است (مثلاً verdict = PASS یا coverage مثل Submitted and indexed).',
  },
  {
    id: 'excluded',
    label: 'ایندکس‌نشده',
    description:
      'درخواست موفق بوده ولی صفحه ایندکس نشده. پیش‌فرض همهٔ زیرحالت‌ها؛ می‌توانید محدود کنید.',
  },
  {
    id: 'error',
    label: 'خطا',
    description:
      'خودِ درخواست وضعیت ایندکس به گوگل ناموفق بوده (مثلاً خطای API یا سهمیه).',
  },
] as const;

export type WebhookBucketFilterId =
  (typeof WEBHOOK_BUCKET_FILTER_OPTIONS)[number]['id'];

const SUB_LABELS = Object.fromEntries(
  EXCLUDED_COVERAGE_FILTER_OPTIONS.map((item) => [item.id, item.labelFa]),
) as Record<string, string>;

export function formatWebhookBucketFilters(filters: string[]): string {
  if (filters.length === 0) return 'بدون فیلتر';

  const parts: string[] = [];
  for (const bucket of WEBHOOK_BUCKET_FILTER_OPTIONS) {
    if (!filters.includes(bucket.id)) continue;
    if (bucket.id === 'excluded') {
      const subs = getExcludedSubFilters(filters);
      if (subs.length === 0) {
        parts.push(`${bucket.label} (همه)`);
      } else {
        const subLabels = subs.map((id) => SUB_LABELS[id] ?? id).join('، ');
        parts.push(`${bucket.label}: ${subLabels}`);
      }
    } else {
      parts.push(bucket.label);
    }
  }
  return parts.join(' · ');
}
